import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=9f1f0b3e&scoped=true"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"
import style0 from "./SMS.vue?vue&type=style&index=0&id=9f1f0b3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1f0b3e",
  null
  
)

export default component.exports